module.exports = __webpack_public_path__ + "media/images/icons/badge-c4b722d5299f24a69574d57d9554c250.svg";